const DEFAULT_UPLOAD_SETTINGS = Object.freeze({ photoBatchLimit: 0, uploadRateLimit: 0, allowVideoUploads: true });

function uploadSettings(settings = {}) {
  return Object.fromEntries(Object.entries(DEFAULT_UPLOAD_SETTINGS).map(([key, fallback]) => [key, settings[key] ?? fallback]));
}

function validUploadSettings(settings) {
  return typeof settings.allowVideoUploads === 'boolean'
    && ['photoBatchLimit', 'uploadRateLimit'].every((key) => Number.isSafeInteger(settings[key]) && settings[key] >= 0 && settings[key] <= 100000);
}

function createUploadLimiter(now = Date.now) {
  const buckets = new Map();
  const windowMs = 10 * 60 * 1000;
  return (req, profileId, limit) => {
    if (limit === 0) return true;
    const time = now();
    const ip = String(req.headers['x-forwarded-for'] || req.socket?.remoteAddress || 'unknown').split(',')[0].trim();
    const key = `${profileId}:${ip}`;
    for (const [id, bucket] of buckets) if (bucket.reset <= time) buckets.delete(id);
    const bucket = buckets.get(key) || { count: 0, reset: time + windowMs };
    if (bucket.count >= limit || (!buckets.has(key) && buckets.size >= 10000)) return false;
    bucket.count += 1;
    buckets.set(key, bucket);
    return true;
  };
}

module.exports = { DEFAULT_UPLOAD_SETTINGS, uploadSettings, validUploadSettings, createUploadLimiter };
